import React from "react";

import { Container } from "react-bootstrap";

import { privacyPolicyEn } from "@/data/privacy-en.html";
import { privacyPolicyFr } from "@/data/privacy-fr.html";

import i18n from "../i18n";

const PrivacyPolicy = () => {
  const { language } = i18n;

  return (
    <Container>
      {language === "fr" ? (
        <div dangerouslySetInnerHTML={{ __html: privacyPolicyFr }} />
      ) : (
        <div dangerouslySetInnerHTML={{ __html: privacyPolicyEn }} />
      )}
    </Container>
  );
};

export default PrivacyPolicy;
